let Page = require('../mixins/base-page');

module.exports = {
	mixins: [Page],

	data() {
		return {
			showQuiz: false
		}
	},

	methods: {
	  	addToQueue(id) {
		  	this.sendRequest('/api/watch-later/course/' + id, 'post');
	  	},
	  	removeFromQueue(id) {
		  	this.sendRequest('/api/unwatch-later/course/' + id, 'post');
	  	},
	  	startQuiz() {
	  		this.showQuiz = true;
	  	},
		resetQuiz() {
	  		this.showQuiz = false;
		}
	}
}
